import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-title-view',
  templateUrl: './page-title-view.component.html',
  styleUrls: ['./page-title-view.component.scss'],
})
export class PageTitleViewComponent {
  @Input() title: string;
  @Input() desc: string;
}
